var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.833,
    y: 6.66797,
    width: 6.66667,
    height: 13.3333,
    transform: "rotate(90 15.833 6.66797)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 8.33398,
    width: 3.33333,
    height: 1.66667,
    transform: "rotate(90 17.5 8.33398)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.584 14.1673C15.5045 14.1673 16.2497 13.4211 16.2497 12.5007V11.8525H17.8122C18.0997 11.8525 18.333 11.6451 18.333 11.3895V8.61177C18.333 8.35621 18.0997 8.1488 17.8122 8.1488H16.2497L16.2497 7.50065C16.2497 6.58018 15.5046 5.83398 14.5841 5.83398C11.7902 5.83398 6.18553 5.83398 3.32783 5.83398C2.40735 5.83398 1.66634 6.58018 1.66634 7.50065V12.5007C1.66634 13.4211 2.40743 14.1673 3.3279 14.1673C6.18416 14.1673 11.7898 14.1673 14.584 14.1673ZM17.2913 9.07473V10.9266H16.2497V9.07473H17.2913ZM3.54134 13.2414C3.0811 13.2414 2.70801 12.8683 2.70801 12.4081L2.70801 7.59325C2.70801 7.13301 3.0811 6.75991 3.54134 6.75991L14.3747 6.75991C14.8349 6.75991 15.208 7.13301 15.208 7.59325L15.208 12.4081C15.208 12.8683 14.8349 13.2414 14.3747 13.2414L3.54134 13.2414Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 12.0833L10.833 7.91667C10.833 7.68655 10.6465 7.5 10.4163 7.5L3.74967 7.5C3.51956 7.5 3.33301 7.68655 3.33301 7.91667L3.33301 12.0833C3.33301 12.3135 3.51956 12.5 3.74967 12.5L10.4163 12.5C10.6465 12.5 10.833 12.3135 10.833 12.0833Z",
    fill: "#61D215"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryHorizontal);
export default __webpack_public_path__ + "static/media/batteryHorizontal.066cb0fd836dacdce9a865e2c2095c2e.svg";
export { ForwardRef as ReactComponent };